<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Avaliação de Encontro' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div *ngIf="!isDiscipulador" class="gradient-extendido"></div>
  <div *ngIf="isDiscipulador" class="wave"></div>

  <form class="sample-form validations-form" [formGroup]="validations_form">
    <ion-row *ngIf="!isDiscipulador">
      <ion-col size="12">
        <h3 class="title">
          {{ getStatusText(mda.status)}}
        </h3>
      </ion-col>
    </ion-row>

    <ion-grid *ngIf="isDiscipulador || mda.status == 1">
      <ion-row class="row-svg-emoticon">
        <ion-col size="12" class="col-img">
          <img
            src="../../../assets/icon/insatisfatorio.svg"
            alt="icon insatisfatorio"
            [hidden]="qualidadeDiscipulo !== 0"
          />
          <img src="../../../assets/icon/icon-neutral.svg" alt="icon neutro" [hidden]="qualidadeDiscipulo !== 1" />
          <img src="../../../assets/icon/excelente.svg" alt="icon excelente" [hidden]="qualidadeDiscipulo !== 2" />
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="text-avaliacao">{{ qualidadeTexto | translate }}</ion-label>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" class="d-flex">
          <i
            class="fa-solid fa-star star"
            *ngFor="let star of estrelas; let i = index"
            (click)="avaliacao(i)"
            [ngClass]="{ 'yellow': i <= qualidadeDiscipulo}"
          >
          </i>
        </ion-col>
      </ion-row>

      <ion-row class="ion-justify-content-center ion-margin-top">
        <ion-col size="5">
          <ion-button
            expand="block"
            fill="outline"
            class="btn-custom"
            type="submit"
            (click)="onSubmit(validations_form.value)"
            >{{'Salvar' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-row *ngIf="!isDiscipulador && mda.status != 1">
      <ion-col size="12">
        <ion-list>
          <p class="avaliacao">{{ 'Somente encontros que foram realizados podem ser avaliados' | translate }}.</p>
        </ion-list>
      </ion-col>
    </ion-row>
  </form>
</ion-content>
